const wowApp = require('angular').module('wowApp.shop');
wowApp.directive('bwsbot', ['$interval', '$window', 'CurrentUserService', 'SettingsService', '$rootScope', 'ShopPageStateService', '$location', '$uibModal', 'StorePickerService', 'AtmService', 'BwsBotService', require('./bws-bot-directive')]);
wowApp.service('BwsBotService', ['ProxyService', '$http', require('./bws-bot-service')]);




/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/bwsbot/index.js
 **/